import { enableProdMode } from '@angular/core'
import { AppComponent } from './app/app.component'
import { environment } from './environments/environment'
import { bootstrapApplication } from '@angular/platform-browser'
import { appConfig } from './app/app.config'
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community'

if (environment.production) {
  enableProdMode()
}

ModuleRegistry.registerModules([
  AllCommunityModule,
])

bootstrapApplication(AppComponent, appConfig)
  // eslint-disable-next-line no-console
  .catch(err => console.error(err))
